// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as RiwayatRouteImport } from './routes/riwayat'
import { Route as PengaturanRouteImport } from './routes/pengaturan'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as BuatRouteImport } from './routes/buat'
import { Route as IndexRouteImport } from './routes/index'
import { Route as RiwayatNoteIdRouteImport } from './routes/riwayat.$noteId'

const RiwayatRoute = RiwayatRouteImport.update({
            id: '/riwayat',path: '/riwayat',getParentRoute: () => rootRouteImport
          })
const PengaturanRoute = PengaturanRouteImport.update({
            id: '/pengaturan',path: '/pengaturan',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const BuatRoute = BuatRouteImport.update({
            id: '/buat',path: '/buat',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const RiwayatNoteIdRoute = RiwayatNoteIdRouteImport.update({
            id: '/$noteId',path: '/$noteId',getParentRoute: () => RiwayatRoute
          })





const RiwayatRouteChildren = {
  RiwayatNoteIdRoute: RiwayatNoteIdRoute
}

const RiwayatRouteWithChildren = RiwayatRoute._addFileChildren(RiwayatRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,BuatRoute: BuatRoute,FaqRoute: FaqRoute,PengaturanRoute: PengaturanRoute,RiwayatRoute: RiwayatRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)